//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { request } from "../../requests";
import 'jsGrid';
export default {
  name: "OrdersTable",
  props: ['context', 'context_id'],

  mounted() {
    jQuery(this.$refs.table).jsGrid({
      width: '100%',
      fields: [{
        type: "text",
        name: "submitted_by",
        title: "Submitted By"
      }, {
        type: "text",
        name: "id",
        title: "Order ID"
      }, {
        type: "text",
        name: "products",
        title: "Service(s)"
      }, {
        type: "text",
        name: "creation_date",
        title: "Ordered"
      }, {
        type: "text",
        name: "completion_date",
        title: "Due"
      }, {
        type: "text",
        name: "business_name",
        title: "Property"
      }, {
        type: "text",
        name: "address",
        title: "Address"
      }],
      height: 'auto',
      editing: false,
      heading: true,
      sorting: true,
      autoload: true,
      filtering: false,
      selecting: true,
      editButton: false,
      noDataContent: 'No Orders Found',
      // Pagination
      paging: true,
      pageSize: 5,
      pageLoading: true,
      controller: {
        loadData: this.onLoadData.bind(this)
      },
      rowClick: this.onDataClicked.bind(this)
    });
  },

  methods: {
    onLoadData(filter = null) {
      let data = filter;
      const url = `/tables/orders/${this.context}/${this.context_id}`;
      return request({
        url: url,
        data,
        method: 'GET',
        spinner: false
      }).then(responseData => {
        return {
          data: responseData.data,
          itemsCount: responseData.count
        };
      });
    },

    onDownloadData() {
      const url = `/tables/orders/${this.context}/${this.context_id}/download`;
      window.open(url, '_blank').focus();
    },

    onDataClicked(data) {}

  }
};